import revive_payload_client_4sVQNw7RlN from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import i18n_yfWm7jX06p from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import vuetify_8NhHJigKc1 from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/plugins/vuetify.js";
import sentry_PZVGm6LH3G from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/plugins/sentry.js";
import vue_apexchart_client_HOS0TXZTxJ from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/plugins/vue-apexchart.client.js";
import date_fns_Z2lKzBQjv0 from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/plugins/date-fns.js";
import vue3_markdown_cJd3NYocvc from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/plugins/vue3-markdown.js";
import vuedraggable_Ic4muabr9a from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/plugins/vuedraggable.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  vuetify_8NhHJigKc1,
  sentry_PZVGm6LH3G,
  vue_apexchart_client_HOS0TXZTxJ,
  date_fns_Z2lKzBQjv0,
  vue3_markdown_cJd3NYocvc,
  vuedraggable_Ic4muabr9a
]